import { createSelector } from "@reduxjs/toolkit";
import { AdminSettings } from "../../types/state";
import { RootState } from "src/store/rootReducer";
import { NameSpace } from "../../const";

export const getSettings = createSelector(
  (state: RootState) => state.gop[NameSpace.Settings],
  (state: AdminSettings) => state.data
);

export const getFetchingStatusSettings = createSelector(
  (state: RootState) => state.gop[NameSpace.Settings],
  (state: AdminSettings) => state.fetchingStatusSettings
);
